(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/image-helpers/assets/javascripts/svg-image.js') >= 0) return;  svs.modules.push('/components/onboarding/image-helpers/assets/javascripts/svg-image.js');
"use strict";

const {
  useContext,
  forwardRef
} = React;
const {
  cdn
} = svs.core.config.data.svsconfig;
const {
  ImageContext
} = svs.components.onboarding.imageHelpers;


const SvgImage = forwardRef((_ref, ref) => {
  let {
    alt,
    imagePath,
    className,
    onLoad,
    isLazy = false
  } = _ref;
  const {
    useLazyImage
  } = useContext(ImageContext);
  const baseClassname = 'pg_content__img';
  const classNames = className ? "".concat(baseClassname, " ").concat(className) : baseClassname;
  const src = "".concat(cdn, "/images/onboarding/").concat(imagePath);
  const LazyImage = useLazyImage(src, !isLazy);
  return React.createElement(LazyImage, {
    alt: alt,
    className: classNames,
    onLoad: onLoad,
    ref: ref,
    src: src
  });
});
setGlobal('svs.components.onboarding.imageHelpers.SvgImage', SvgImage);

 })(window);